import { AuthContext } from '##/contexts/authContext';
import { useContext } from 'preact/hooks';

const useAuth = () => useContext(AuthContext);

export default useAuth;
